var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      staticClass: "gh-card gh-card--text",
      class: { "gh-card--collapsed": _vm.collapsed },
    },
    [
      _vm._t("context-head"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "gh-card-text__header" },
        [
          _c("div", { staticClass: "gh-card-text__header-left" }, [
            _c(
              "button",
              {
                staticClass: "gh-card__chevron",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("toggle-collapse")
                  },
                },
              },
              [
                _c("i", {
                  class: _vm.collapsed
                    ? "fa fa-chevron-up"
                    : "fa fa-chevron-down",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "gh-card-text__title",
                class: {
                  "gh-dnd-source":
                    _vm.canDrag && _vm.posterUrl && _vm.outputBody,
                },
                attrs: {
                  draggable: _vm.canDrag && !!_vm.posterUrl && !!_vm.outputBody,
                },
                on: {
                  dragstart: _vm.onConceptTextDragStart,
                  dragend: _vm.onDragEnd,
                },
              },
              [_vm._v(_vm._s(_vm.cardTitle))]
            ),
          ]),
          _vm._v(" "),
          _c("GenerationHistoryDesignCardActions", {
            attrs: {
              "is-favorite": _vm.card.is_favorite,
              "is-copied": _vm.isCopied,
              "is-image-copied": _vm.isImageCopied,
              "show-copy-image": !!_vm.posterUrl,
              "show-copy": true,
              "show-copy-prompt": false,
            },
            on: {
              copy: function ($event) {
                return _vm.$emit("copy")
              },
              "copy-image": function ($event) {
                return _vm.$emit("copy-image", _vm.$refs.posterImage)
              },
              download: function ($event) {
                return _vm.$emit("download")
              },
              favorite: function ($event) {
                return _vm.$emit("favorite")
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "GenerationHistoryCardSlide",
        { attrs: { expanded: !_vm.collapsed } },
        [
          _c("div", { staticClass: "gh-card-text__body" }, [
            _c(
              "div",
              {
                staticClass: "gh-card-text__output",
                class: { "gh-card-text__output--with-poster": !!_vm.posterUrl },
              },
              [
                _vm.posterUrl
                  ? _c(
                      "div",
                      { staticClass: "gh-card-text__output-images-wrap" },
                      [
                        _c(
                          "div",
                          { staticClass: "gh-card-text__output-images" },
                          [
                            _c("img", {
                              ref: "posterImage",
                              staticClass:
                                "gh-card-text__output-image gh-card-text__output-image--single",
                              class: { "gh-dnd-source": _vm.canDrag },
                              attrs: {
                                src: _vm.posterUrl,
                                alt: "",
                                draggable: _vm.canDrag,
                              },
                              on: {
                                dragstart: function ($event) {
                                  return _vm.onPosterDragStart(
                                    $event,
                                    _vm.posterUrl,
                                    _vm.posterIndex
                                  )
                                },
                                dragend: _vm.onDragEnd,
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.outputBody
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "gh-card-text__output-text gh-card-text__field-value--output",
                                class: {
                                  "gh-dnd-source":
                                    _vm.canDrag && _vm.outputBody,
                                },
                                attrs: {
                                  draggable: _vm.canDrag && !!_vm.outputBody,
                                },
                                on: {
                                  dragstart: _vm.onConceptTextDragStart,
                                  dragend: _vm.onDragEnd,
                                },
                              },
                              [
                                _c("GenerationHistoryPromptPopover", {
                                  attrs: { text: _vm.outputBody, tooltip: "" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    )
                  : _c(
                      "p",
                      {
                        staticClass: "gh-card__text",
                        class: {
                          "gh-dnd-source": _vm.canDrag && _vm.outputBody,
                        },
                        attrs: { draggable: _vm.canDrag && !!_vm.outputBody },
                        on: {
                          dragstart: _vm.onConceptTextDragStart,
                          dragend: _vm.onDragEnd,
                        },
                      },
                      [_vm._v(_vm._s(_vm.outputBody))]
                    ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "gh-card-text__meta" },
              [
                _c("GenerationHistoryMetaRows", {
                  attrs: {
                    fields: _vm.metaFields,
                    variant: "detail",
                    "row-key-prefix": `concept-${_vm.card.item_id}-${_vm.posterIndex}`,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }